import { computed } from "mobx"
import { observer } from "mobx-react"
import { Table, Typography } from "antd"
import { ColumnsType } from "antd/es/table"

import { IdItem } from "@src/app/components/tableRowItems/idItem"
import { GlobalCurrenciesCollection } from "@src/app/CurrenciesCollection"
import { TransactionsCollection } from "@src/app/transactionsStore/TransactionsCollection"
import { Transaction } from "@src/app/transactionsStore/TransactionsCollection/types"
import { ReportsTableExpandable } from "@src/pages/reports/ui/ReportsTable/ReportsTableExpandable"
import { dateTimeFormat } from "@src/shared/date"

type Props = {
  collection: TransactionsCollection
}
export const ReportsTable = observer(({ collection }: Props) => {
  const reportsColumns: ColumnsType<Transaction> = [
    {
      dataIndex: "id",
      render: (_, { id }) => <IdItem id={id} />,
      title: "Custom ID",
    },
    {
      dataIndex: "created_at",
      render: (_, { created_at }) => dateTimeFormat(created_at as string),
      title: "Date and Time",
    },
    {
      dataIndex: "operation",
      render: (_, { operation: { resource } }) => resource,
      title: "Type",
    },
    {
      dataIndex: "currency",
      render: (_, { operation: { network, symbol } }) => {
        const currency = GlobalCurrenciesCollection().getBySymbolNetwork({
          network: network,
          symbol: symbol,
        })

        return (
          <Typography.Text>
            {currency?.symbol_alias ?? symbol} ({network})
          </Typography.Text>
        )
      },
      title: "Currency",
    },
    {
      dataIndex: "status",
      title: "Status",
    },
    {
      dataIndex: "amount",
      render: (_, { operation: { amount } }) => amount,
      title: "Amount",
    },
    {
      dataIndex: "operation",
      render: (_, { operation: { fee } }) => {
        const currency = fee
          ? GlobalCurrenciesCollection().getBySymbolNetwork({
              network: fee?.network,
              symbol: fee?.symbol,
            })
          : undefined

        return (
          <Typography.Text>
            {fee?.amount
              ? `${fee.amount} ${currency?.symbol_alias ?? fee.symbol} (${fee.network})`
              : 0}
          </Typography.Text>
        )
      },
      title: "Fee",
    },
    {
      dataIndex: "operation",
      render: (_, { final }) => {
        const currency = GlobalCurrenciesCollection().getBySymbolNetwork({
          network: final.network,
          symbol: final.symbol,
        })

        return (
          <Typography.Text>
            {final?.amount} {currency?.symbol_alias ?? final?.symbol} (
            {final?.network})
          </Typography.Text>
        )
      },
      title: "Amount credited",
    },
  ]

  const list = computed(() => {
    return collection.items.filter((i) => i.status !== "archived")
  }).get()

  return (
    <Table
      columns={reportsColumns}
      dataSource={list}
      expandable={{
        expandedRowRender: (record) => (
          <ReportsTableExpandable
            isLoading={collection.isLoading}
            transaction={record as any}
          />
        ),
      }}
      loading={collection.isLoading}
      pagination={collection.pagination}
      rowKey="id"
    />
  )
})
